// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Adjust to your navbar height (px)
const DEFAULT_OFFSET = 88;

export default function ScrollToTop({ offset = DEFAULT_OFFSET } = {}) {
  const { pathname, hash } = useLocation();

  // Turn off browser auto-restoration for SPA nav
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = prev;
      };
    }
  }, []);

  useEffect(() => {
    // If navigating to an anchor (e.g., /do-not-sell#ads), scroll that element into view with offset
    if (hash) {
      const id = hash.slice(1);
      let tries = 0;
      const maxTries = 10;

      const scrollToAnchor = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else if (tries < maxTries) {
          tries += 1;
          // Try again after layout/images render
          setTimeout(scrollToAnchor, 50);
        }
      };

      // Wait a frame so the DOM has painted
      requestAnimationFrame(scrollToAnchor);
      return;
    }

    // Otherwise, on normal route change, go to top
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, offset]);

  return null;
}
